import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { BatchAttendanceImportCompareRequest } from "../../shared/batch-attendance-import-compare-request";

@Component({
	selector: "app-batch-attendance-csv-upload",
	templateUrl: "./batch-attendance-csv-upload.component.html",
	styleUrls: ["./batch-attendance-csv-upload.component.css"],
})
export class BatchAttendanceCsvUploadComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {}

	///////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////

	FormatOptionID: number = 1;
	lstFormatOption: any = [
		{
			ID: 1,
			Desc: ".csv (Comma Delimited)",
		},
		{
			ID: 2,
			Desc: ".txt (Tab Delimited)",
		},
	];

	SkipFirstLineID: number = 1;
	lstSkipFirstLine: any = [
		{
			ID: 1,
			Desc: "Don't Skip (No Headers)",
		},
		{
			ID: 2,
			Desc: "Skip Headers",
		},
	];

	ImportFile: any;
	FileData: any;
	FileName: string = "";

	lstTable: any = [];
	lstCols: any = [];
	OptArray: number[] = [];

	PreviewLines: number = 3;
	lstRequiredColumns: any = [
		{
			ID: 0,
			Desc: "- Ignore Column -",
			Required: false,
			IsOption: false,
		},
		{
			ID: 1,
			Desc: "Student ID",
			Required: true,
			IsOption: false,
		},
		{
			ID: 2,
			Desc: "Date",
			Required: true,
			IsOption: false,
		},
		{
			ID: 3,
			Desc: "Attendance Status",
			Required: false,
			IsOption: true,
		},
		{
			ID: 4,
			Desc: "Entry Time",
			Required: false,
			IsOption: true,
		},
		{
			ID: 5,
			Desc: "Excuse Code",
			Required: false,
			IsOption: true,
		},
		{
			ID: 6,
			Desc: "Excuse Description",
			Required: false,
			IsOption: true,
		},
		{
			ID: 7,
			Desc: "Comments",
			Required: false,
			IsOption: true,
		},
	];

	ReadyToImport: boolean = false;

	LoadingFile: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	pagerows: any = 10;
	pagefirst: any = 0;

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////

	onUploadStart() {
		this.errorMessage = "";

		document.getElementById("ImportInput").click();
	}

	onFileToImportChange(val) {
		this.ImportFile = val.target.files[0];

		if (this.ImportFile != undefined && this.ImportFile.name != undefined) {
			this.FileName = this.ImportFile.name;
		}

		if (this.ImportFile.type != "text/plain" && this.ImportFile.type != "text/csv") {
			this.errorMessage =
				"Invalid File Type. You might want to create a new Excel file, type in the Student IDs, Dates, and new attendance statuses and save the file as a .csv (comma-delimited)";
			return;
		}

		var fr = new FileReader();
		fr.readAsText(this.ImportFile);
		// fr.readAsDataURL(this.ImportFile);

		fr.onload = () => {
			this.FinishLoadFile(fr.result);
		};
	}

	FinishLoadFile(f) {
		this.FileData = f;
		this.ParsePreviewData();
	}

	ParsePreviewData() {
		// console.log("Parse Data");

		this.LoadingFile = true;
		this.ReadyToImport = false;

		this.lstTable = [];
		this.lstCols = [];

		if (this.FormatOptionID == 1) {
			this.ParsePreviewCsvData();
		} else if (this.FormatOptionID == 2) {
			this.ParsePreviewTabData();
		}
	}

	ParsePreviewTabData() {
		try {
			var lines: string[] = [];

			if (this.FileData.indexOf("\r\n") >= 0) {
				lines = this.FileData.split("\r\n");
			} else if (this.FileData.indexOf("\n") >= 0) {
				lines = this.FileData.split("\n");
			}

			for (var z = 0; z < lines.length; z++) {
				var next = lines[z];

				var tabs = next.split("\t");

				if (this.SkipFirstLineID == 0 || z > 0) {
					this.lstTable = [...this.lstTable, tabs];
				}

				if (z >= this.PreviewLines - 1 + this.SkipFirstLineID) {
					break;
				}
			}

			for (var z = 0; z < this.lstTable[0].length; z++) {
				this.lstCols = [...this.lstCols, 0];
				this.OptArray.push(0);
			}

			this.LoadingFile = false;
			this.ReadyToImport = true;
		} catch (e) {
			console.log(e);
			this.LoadingFile = false;
			this.ReadyToImport = false;
		}
	}

	ParsePreviewCsvData() {
		try {
			var lines: string[] = [];

			if (this.FileData.indexOf("\r\n") >= 0) {
				lines = this.FileData.split("\r\n");
			} else if (this.FileData.indexOf("\n") >= 0) {
				lines = this.FileData.split("\n");
			}

			var nextLine = [];
			var nextCol = "";
			var inQuotes = false;

			for (var z = 0; z < lines.length; z++) {
				var line = lines[z];

				for (var i = 0; i < line.length; i++) {
					var next = line[i];

					if (next == '"') {
						inQuotes = !inQuotes;
					} else if (next == ",") {
						if (inQuotes == false) {
							nextLine.push(String(nextCol));
							nextCol = "";
						} else {
							nextCol += next;
						}
					} else {
						nextCol += next;
					}
				}

				if (nextCol != null && nextCol != "") {
					nextLine.push(String(nextCol));
					nextCol = "";
				}

				if (this.SkipFirstLineID == 0 || z > 0) {
					this.lstTable = [...this.lstTable, nextLine];
				}
				nextLine = [];

				if (z >= this.PreviewLines - 1 + this.SkipFirstLineID) {
					break;
				}
			}

			for (var z = 0; z < this.lstTable[0].length; z++) {
				this.lstCols = [...this.lstCols, 0];
				this.OptArray.push(0);
			}

			this.LoadingFile = false;
			this.ReadyToImport = true;
		} catch (e) {
			console.log(e);
			this.LoadingFile = false;
			this.ReadyToImport = false;
		}
	}

	onImport() {
		this.errorMessage = "";

		//
		//  Validate Cols
		//

		var StudentIDCount = 0;
		var DateCount = 0;
		var StatusCount = 0;
		var TimeCount = 0;
		var ExcuseCDCount = 0;
		var ExcuseDescCount = 0;
		var CommentsCount = 0;
		var HasOptions = false; // Need Student ID, Date + at least 1 option (Ex. status)

		var StudentIDCol = -1;
		var DateCol = -1;
		var StatusCol = -1;
		var TimeCol = -1;
		var ExcuseCDCol = -1;
		var ExcuseDescCol = -1;
		var CommentsCol = -1;

		for (var z = 0; z < this.OptArray.length; z++) {
			var next = this.OptArray[z];

			if (next == 1) {
				StudentIDCol = z;
				StudentIDCount++;
			}
			if (next == 2) {
				DateCol = z;
				DateCount++;
			}
			if (next == 3) {
				StatusCol = z;
				StatusCount++;
			}
			if (next == 4) {
				TimeCol = z;
				TimeCount++;
			}
			if (next == 5) {
				ExcuseCDCol = z;
				ExcuseCDCount++;
			}
			if (next == 6) {
				ExcuseDescCol = z;
				ExcuseDescCount++;
			}
			if (next == 7) {
				CommentsCol = z;
				CommentsCount++;
			}
		}

		if (StatusCount > 0 || TimeCount > 0 || ExcuseCDCount > 0 || ExcuseDescCount > 0 || CommentsCount > 0) {
			HasOptions = true;
		}

		//
		//  Check for missing options
		//
		if (StudentIDCount == 0) {
			this.errorMessage = "Select which column represents Student ID";
			return;
		}
		if (DateCount == 0) {
			this.errorMessage = "Select which column represents the date attendance was taken";
			return;
		}
		if (HasOptions == false) {
			this.errorMessage = "Select which column represents a value to change. Ex. you can have one column represent the correct attendance status";
			return;
		}

		//
		//  Check for dup columns
		//
		if (StudentIDCount > 1) {
			this.errorMessage = "Only 1 column can represent Student ID";
			return;
		}
		if (DateCount > 1) {
			this.errorMessage = "Only 1 column can represent the attendance date";
			return;
		}
		if (StatusCount > 1) {
			this.errorMessage = "Only 1 column can represent attendance status";
		}
		if (TimeCount > 1) {
			this.errorMessage = "Only 1 column can represent entry time";
		}
		if (ExcuseCDCount > 1) {
			this.errorMessage = "Only 1 column can represent excuse code";
		}
		if (ExcuseDescCount > 1) {
			this.errorMessage = "Only 1 column can represent excuse description";
		}
		if (CommentsCount > 1) {
			this.errorMessage = "Only 1 column can represent comments";
		}

		var ParseResult = this.ParseAllData(StudentIDCol, DateCol, StatusCol, TimeCol, ExcuseCDCol, ExcuseDescCol, CommentsCol);

		var parms: BatchAttendanceImportCompareRequest = {
			lstStudentID: ParseResult[0],
			lstEntryDate: ParseResult[1],
			lstAttendanceStatusCD: ParseResult[2],
			lstEntryTime: ParseResult[3],
			lstExcuseCD: ParseResult[4],
			lstExcuseDesc: ParseResult[5],
			lstComments: ParseResult[6],
		};

		this.ref.close(parms);
	}

	ParseAllData(StudentIDCol: number, DateCol: number, StatusCol: number, TimeCol: number, ExcuseCDCol: number, ExcuseDescCol: number, CommentsCol: number) {
		if (this.FormatOptionID == 1) {
			return this.ParseAllCsvData(StudentIDCol, DateCol, StatusCol, TimeCol, ExcuseCDCol, ExcuseDescCol, CommentsCol);
		} else if (this.FormatOptionID == 2) {
			return this.ParseAllTabData(StudentIDCol, DateCol, StatusCol, TimeCol, ExcuseCDCol, ExcuseDescCol, CommentsCol);
		}
	}

	ParseAllTabData(
		StudentIDCol: number,
		DateCol: number,
		StatusCol: number,
		TimeCol: number,
		ExcuseCDCol: number,
		ExcuseDescCol: number,
		CommentsCol: number
	): [string[], string[], string[], string[], string[], string[], string[]] {
		var lstStudentID: string[] = [];
		var lstEntryDate: string[] = [];
		var lstAttendanceStatusCD: string[] = [];
		var lstEntryTime: string[] = [];
		var lstExcuseCD: string[] = [];
		var lstExcuseDesc: string[] = [];
		var lstComments: string[] = [];

		try {
			var lines: string[] = [];

			if (this.FileData.indexOf("\r\n") >= 0) {
				lines = this.FileData.split("\r\n");
			} else if (this.FileData.indexOf("\n") >= 0) {
				lines = this.FileData.split("\n");
			}

			for (var z = 0; z < lines.length; z++) {
				var next = lines[z];
				var tabs = next.split("\t");

				if (this.SkipFirstLineID == 0 || z > 0) {
					lstStudentID.push(tabs[StudentIDCol]);
					lstEntryDate.push(tabs[DateCol]);

					if (StatusCol >= 0) {
						lstAttendanceStatusCD.push(tabs[StatusCol]);
					}
					if (TimeCol >= 0) {
						lstEntryTime.push(tabs[TimeCol]);
					}
					if (ExcuseCDCol >= 0) {
						lstExcuseCD.push(tabs[ExcuseCDCol]);
					}
					if (ExcuseDescCol >= 0) {
						lstExcuseDesc.push(tabs[ExcuseDescCol]);
					}
					if (CommentsCol >= 0) {
						lstComments.push(tabs[CommentsCol]);
					}
				}
			}
		} catch (e) {
			console.log(e);
		}

		return [lstStudentID, lstEntryDate, lstAttendanceStatusCD, lstEntryTime, lstExcuseCD, lstExcuseDesc, lstComments];
	}

	ParseAllCsvData(
		StudentIDCol: number,
		DateCol: number,
		StatusCol: number,
		TimeCol: number,
		ExcuseCDCol: number,
		ExcuseDescCol: number,
		CommentsCol: number
	): [string[], string[], string[], string[], string[], string[], string[]] {
		var lstStudentID: string[] = [];
		var lstEntryDate: string[] = [];
		var lstAttendanceStatusCD: string[] = [];
		var lstEntryTime: string[] = [];
		var lstExcuseCD: string[] = [];
		var lstExcuseDesc: string[] = [];
		var lstComments: string[] = [];

		try {
			var lines: string[] = [];

			if (this.FileData.indexOf("\r\n") >= 0) {
				lines = this.FileData.split("\r\n");
			} else if (this.FileData.indexOf("\n") >= 0) {
				lines = this.FileData.split("\n");
			}

			var nextLine = [];
			var nextCol = "";
			var inQuotes = false;

			for (var z = 0; z < lines.length; z++) {
				var line = lines[z];

				for (var i = 0; i < line.length; i++) {
					var next = line[i];

					if (next == '"') {
						inQuotes = !inQuotes;
					} else if (next == ",") {
						if (inQuotes == false) {
							nextLine.push(String(nextCol));
							nextCol = "";
						} else {
							nextCol += next;
						}
					} else {
						nextCol += next;
					}
				}

				if (nextCol != null && nextCol != "") {
					nextLine.push(String(nextCol));
					nextCol = "";
				}

				// console.log("Next Line");
				// console.log(nextLine);

				if (this.SkipFirstLineID == 0 || z > 0) {
					if (nextLine.length > 0) {
						lstStudentID.push(nextLine[StudentIDCol]);
						lstEntryDate.push(nextLine[DateCol]);

						if (StatusCol >= 0) {
							lstAttendanceStatusCD.push(nextLine[StatusCol]);
						}
						if (TimeCol >= 0) {
							lstEntryTime.push(nextLine[TimeCol]);
						}
						if (ExcuseCDCol >= 0) {
							lstExcuseCD.push(nextLine[ExcuseCDCol]);
						}
						if (ExcuseDescCol >= 0) {
							lstExcuseDesc.push(nextLine[ExcuseDescCol]);
						}
						if (CommentsCol >= 0) {
							lstComments.push(nextLine[CommentsCol]);
						}
					}
				}

				nextLine = [];
			}
		} catch (e) {
			console.log(e);
		}

		return [lstStudentID, lstEntryDate, lstAttendanceStatusCD, lstEntryTime, lstExcuseCD, lstExcuseDesc, lstComments];
	}

	onClose() {
		this.ref.close(0);
	}

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////

	onFormatOptionIDChange(val) {
		this.FormatOptionID = val;

		if (this.ImportFile != null) {
			this.ParsePreviewData();
		}
	}

	onSkipFirstLineIDChange(val) {
		this.SkipFirstLineID = val;

		if (this.ImportFile != null) {
			this.ParsePreviewData();
		}
	}

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingFile == true || this.Processing == true;
	}

	///////////////////////////////////////////////////////////////////////
}
